/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unnecessary-type-constraint */
export class ClientError extends Error {
    constructor(code, message, status, data) {
        super(message);
        this.code = code;
        this.message = message;
        this.status = status;
        this.data = data;
    }
}
//# sourceMappingURL=errors.js.map